import React, { Component } from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import anuncioico from "../../assets/AnuncioICO.svg";

import '../../css/ComponenteContrasenia.css';

export class ComponenteContrasenia extends Component {

  constructor(props) {
    super(props);
    this.state = {
      nombres: this.props.nombres,
      apellidos: this.props.apellidos,
      username: this.props.usuario,
      isUpdateePss: this.props.isUpdateePss,
      showPassword: false,
      showRepetirPassw: false,
      showActualPassword: false,
      datos: {
        contrasenaactual:"",
        contrasena: "",
        repetirContrasena: "",
      },
      verIconContra: false,
      verCheckContra: false,
      verIconRepContra: false,
      verCheckRepContra: false,
      verIconRepContraAct: false,
      verCheckRepContraAct: false,
    };
    this.mostrarContrasena = this.mostrarContrasena.bind(this);
    this.mostrarContrasenaActual = this.mostrarContrasenaActual.bind(this);
    this.mostrarReptirContrasena = this.mostrarReptirContrasena.bind(this);
    this.validacion = this.validacion.bind(this);
  }
  componentDidMount() {
    //console.log(this.state.isUpdateePss);
  }

    mostrarContrasena(e){
        e.preventDefault();
        this.setState({showPassword:!this.state.showPassword});
    }

    mostrarReptirContrasena(e){
        e.preventDefault();
        this.setState({showRepetirPassw:!this.state.showRepetirPassw});
    }

    mostrarContrasenaActual(e) {
      e.preventDefault();
      //console.log("mostrarContrasenaActual");
      /*this.setState({showActualPassword:!this.state.showActualPassword});*/
      this.setState({
        showActualPassword: !this.state.showActualPassword
      });
      //console.log(this.state.showActualPassword);
      //console.log(this.state.datos);

    }
  
  handlerContrasenaActual = async (e) => {
      await this.setState({
        datos: {
          ...this.state.datos,
          [e.target.name]: e.target.value,
        }
      })
    //console.log(this.state.datos);
    this.handlerContrasCorrectas(e);
    }

    handlerContrasena=async(e)=>{
        //ver que se cumplan las reglas usar expresiones regulares mejor
        //console.log(e.target.value);
        await this.setState({
            datos:{
                ...this.state.datos,
                [e.target.name]:e.target.value,
            }
        })
        //console.log(this.state.datos);
        if (this.state.datos.contrasena !== "") {
           // console.log("entra a validación");
            this.validacion();
        }else{
            this.setState({verIconContra:false});

        }
        this.handlerContrasCorrectas(e);
        
    }

    handlerContrasCorrectas = async (e) => {
      // console.log(this.state.datos);
        if(this.state.datos.contrasena.length >0){
            await this.setState({
                datos:{
                    ...this.state.datos,
                    [e.target.name]:e.target.value,
                }
            })
            if(this.state.datos.repetirContrasena===""){
                //console.log("input repetir vacio")
              this.setState({ verIconRepContra: false });
              this.props.cambiarEstado(this.state.datos.contrasenaactual, this.state.datos.repetirContrasena, this.state.verCheckContra, this.state.verCheckRepContra);
                //console.log(this.state.verCheckRepContra);
            }
            else if(this.state.datos.contrasena!== this.state.datos.repetirContrasena){
                //console.log("las contraseñas son diferentes");
                
                this.setState({verIconRepContra:true});
                this.setState({verCheckRepContra:false});
              this.props.cambiarEstado(this.state.datos.contrasenaactual, this.state.datos.repetirContrasena,this.state.verCheckContra,this.state.verCheckRepContra);
                //console.log(this.state.verCheckRepContra);

            } else{
                //console.log('son iguales');
                this.setState({ verIconRepContra: true });
                if (this.state.verCheckContra) {
                    this.setState({ verCheckRepContra: true });
                }
                
                //console.log(this.state.verCheckRepContra);
              this.props.cambiarEstado(this.state.datos.contrasenaactual, this.state.datos.repetirContrasena,this.state.verCheckContra,this.state.verCheckRepContra);
            }
        }
    } 


notContainsname() {
    //console.log(this.state.apellidos);
    //console.log(this.state.nombres);
        let contraseña_temp=this.state.datos.contrasena.toLocaleLowerCase();
        for (var i = 0; i < this.state.nombres.split(" ").length; i++){
            if (this.state.nombres.split(" ")[i].toLocaleLowerCase()!= "") {
                if (contraseña_temp.includes(this.state.nombres.split(" ")[i].toLocaleLowerCase())) {
                   // console.log(this.state.nombres.split(" ")[i].toLocaleLowerCase());
                    //console.log("contraseña temp: " + contraseña_temp);
                    return false;
                }
            }
        } for (var i = 0; i < this.state.apellidos.split(" ").length; i++){
            if (this.state.apellidos.split(" ")[i].toLocaleLowerCase() != "") {
                if (contraseña_temp.includes(this.state.apellidos.split(" ")[i].toLocaleLowerCase())) {
                   // console.log(this.state.nombres.split(" ")[i].toLocaleLowerCase());
                   // console.log("contraseña temp: " + contraseña_temp);
                    return false;
                }
            }
        }
        return true;
        /*
        let nombre1=this.state.nombres.split(" ")[0].toLocaleLowerCase();
        let nombre2=this.state.nombres.split(" ")[1].toLocaleLowerCase();
        let apellido1=this.state.apellidos.split(" ")[0].toLocaleLowerCase();
        let apellido2=this.state.apellidos.split(" ")[1].toLocaleLowerCase();
        let contraseña_temp=this.state.datos.contrasena.toLocaleLowerCase();

        if(contraseña_temp.includes(nombre1) || contraseña_temp.includes(nombre2)||contraseña_temp.includes(apellido1)|| contraseña_temp.includes(apellido2) || contraseña_temp.includes(nombre1.toUpperCase()) ||contraseña_temp.includes(nombre2.toUpperCase())||contraseña_temp.includes(apellido1.toUpperCase()) || contraseña_temp.includes(apellido2.toUpperCase()) ){
            //console.log("ERROR!! incluye nombres");
            return false;
        }else{
            return true;
        }
        return true;*/
  }

  notContainUser() {
    if(this.state.username==null || this.state.username == ""){
      return true;
    }
    let contraseña_temp = this.state.datos.contrasena.toLocaleLowerCase();
    if (contraseña_temp.toLocaleLowerCase() != "") {
      if (contraseña_temp.includes(this.state.username.toLocaleLowerCase())) {
        return false;
      }
    }
    return true;
  }

    validacion(){
      //  console.log(this.state.datos.contrasena);
      //  console.log(this.props.expresionRegular.test(this.state.datos.contrasena));
      // console.log(this.notContainsname())
      // console.log(this.notContainUser())
      // console.log(this.state.username)
      if (this.props.expresionRegular.test(this.state.datos.contrasena) && this.notContainsname() && this.notContainUser()){
            //console.log("correcta regex");
            this.setState({verIconContra:true});
            this.setState({verCheckContra:true});
        }
        else{
            //console.log("incorrecta regex");
            this.setState({verIconContra:true});
            this.setState({ verCheckContra: false });
            //this.setState({ verCheckRepContra: false });
        }
        
    }

    render() {
        return (
            <div align="justify" >                
              {false &&
                <div className="row">
                    <div className="col-md-2 col-xl-3">

                    </div>
                    <div className={`form-group ${this.props.columnas} mt-2`}>
                      <label>Contraseña Actual:</label>
                      <div className="input-group">
                        <input
                          type={this.state.showActualPassword ? "text" : "password"}
                          className="form-control"
                          data-toggle="password"
                        name="contrasenaactual"
                        onChange={this.handlerContrasenaActual}
                        />
                        <button onClick={this.mostrarContrasenaActual} className="input-group-text pb-6">
                          {this.state.showActualPassword ? <FontAwesomeIcon icon={faEye}></FontAwesomeIcon> : <FontAwesomeIcon icon={faEyeSlash}></FontAwesomeIcon>}
                        </button>
                       
                      </div>
                    </div>
                  </div>
                }

                <div className="row">
                    <div className="col-md-2 col-xl-3">

                    </div>
                        <div className={`form-group ${this.props.columnas} mt-2`}>
                            <label>Nueva Contraseña:</label>
                            <div className="input-group">

                                <input
                                    type={this.state.showPassword ? "text" : "password"}
                                    className="form-control"
                                    data-toggle="password"
                                    name="contrasena"
                                    onChange={this.handlerContrasena}
                                />
                                <button onClick={this.mostrarContrasena} className="input-group-text pb-6">
                                    {this.state.showPassword ? <FontAwesomeIcon icon={faEye}></FontAwesomeIcon> : <FontAwesomeIcon icon={faEyeSlash}></FontAwesomeIcon>}
                                </button>
                                {this.state.verIconContra === true ?
                                    (<span>
                                        {this.state.verCheckContra ? <FontAwesomeIcon icon={faCheckCircle} id="compContra-checkIcon"></FontAwesomeIcon>
                                            : <FontAwesomeIcon icon={faTimesCircle} id="compContra-xIcon"></FontAwesomeIcon>}
                                    </span>) : null
                                }
                            </div>
                        </div>
                </div>
             
                <div className="row">
                    <div className="col-md-2 col-xl-3">
                    </div>
                    <div className={`form-group ${this.props.columnas} mt-2`}>
                        <label>Repetir Nueva Contraseña:</label>
                        <div className="input-group">

                            <input
                                type={this.state.showRepetirPassw ? "text" : "password"}
                                className="form-control"
                                data-toggle="password"
                                name="repetirContrasena"
                                onChange={this.handlerContrasCorrectas}
                            />

                            <button onClick={this.mostrarReptirContrasena} className="input-group-text">
                                {this.state.showRepetirPassw ? <FontAwesomeIcon icon={faEye}></FontAwesomeIcon> : <FontAwesomeIcon icon={faEyeSlash}></FontAwesomeIcon>}
                            </button>
                            {this.state.verIconRepContra === true ?
                                (<span>
                                    {this.state.verCheckRepContra ? <FontAwesomeIcon icon={faCheckCircle} id="compContra-checkIcon"></FontAwesomeIcon>
                                        : <FontAwesomeIcon icon={faTimesCircle} id="compContra-xIcon"></FontAwesomeIcon>}
                                </span>) : null
                            }
                        </div>
                    </div>
                
                </div>

             

            </div>
        )
    }
}

export default ComponenteContrasenia
